import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=0456b660&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports